/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const h = 'is-hidden';

	const mainVis = () => {
		const video = document.querySelector('.top-mainVis video');
		const texts = [
			document.querySelector('.top-mainVis ._text1'),
			document.querySelector('.top-mainVis ._text2'),
			document.querySelector('.top-mainVis ._text3'),
			document.querySelector('.top-mainVis ._text4'),
			document.querySelector('.top-mainVis ._text5'),
			document.querySelector('.top-mainVis ._text6')
		];
		const timings = [
			{ show: 0, hide: 5.25 },
			{ show: 5.25, hide: 10.25 },
			{ show: 10.25, hide: 15.05 },
			{ show: 15.05, hide: 20.15 },
			{ show: 20.15, hide: 23.4 },
			{ show: 23.4, hide: 999 }
		];

		let currentIndex = -1;
		let timers = [];

		const clearTimers = () => {
			timers.forEach(clearTimeout);
			timers = [];
		};
		const resetAnime = () => {
			texts.forEach(text => {
				text.classList.remove(a);
				text.classList.add(h);
			});
		};
		const showText = (index) => {
			const text = texts[index];

			// 0.2s待ってからactive
			const t1 = setTimeout(() => {
				text.classList.remove(h);

				const t2 = setTimeout(() => {
					text.classList.add(a);
				}, 200);

				timers.push(t2);
			}, 100); // 前テキストhide後0.1s

			timers.push(t1);
		};
		const hideText = (index) => {
			const text = texts[index];
			text.classList.add(h);
			text.classList.remove(a);
		};

		video.addEventListener('canplay', () => {
			resetAnime();
			video.play();
		});
		video.addEventListener('timeupdate', () => {
			const t = video.currentTime;

			let newIndex = -1;
			timings.forEach((range, i) => {
				if (t >= range.show && t < range.hide) {
					newIndex = i;
				}
			});
			if (newIndex !== currentIndex) {
				clearTimers();

				if (currentIndex !== -1) {
					hideText(currentIndex);
				}
				if (newIndex !== -1) {
					showText(newIndex);
				}
				currentIndex = newIndex;
			}
		});
		video.addEventListener('ended', () => {
			setTimeout(() => {
				video.currentTime = 0;
				video.play();
			}, 3000);
		});

		const button = document.querySelector('.__videoControl');

		button.addEventListener('click', () => {
			if (video.paused) {
				video.currentTime = 0;
				video.play();
				button.classList.remove('is-paused');
			} else {
				video.pause();
				button.classList.add('is-paused');
			}
		});
	};

	const topicsSlider = () => {
		const swiper = new Swiper('.top-topics-slider.swiper', {
			loop: true,
			loopAdditionalSlides: 1,
			effect: 'slide',
			speed: 500,
			autoplay: false,
			slidesPerView: 'auto',
			spaceBetween: 32,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 'auto',
					spaceBetween: 32,
				},
				1025: {
					slidesPerView: 4,
					spaceBetween: 40,
					pagination: false,
				}
			}
		});
		FUNCTIONS.matchHeight(document.querySelectorAll('.top-topics-slider.swiper .__item .__body'));
	};

	const newsList = () => {
		const jsonURL = `/ajax${FUNCTIONS.va.isEnglish ? '/english' : ''}/news/list.json`;
		const jsonURLirPocket = FUNCTIONS.va.isEnglish ? 'https://xml.irpocket.com/4461/JS/release-enall-all.js' : 'https://xml.irpocket.com/4461/JS/release-all-all.js';
		console.log(jsonURL);

		function loadIRPocket() {
			return new Promise((resolve) => {
				window.ir20handler = function (data) {
					resolve(data.item || []);
				};

				const script = document.createElement('script');
				script.src = jsonURLirPocket;
				script.onerror = () => resolve([]); // 失敗しても空配列
				document.body.appendChild(script);
			});
		}
		async function fetchAndMergeNews() {
			const news1Promise = fetch(jsonURL)
				.then(res => res.ok ? res.json() : [])
				.catch(() => []);

			const news2Promise = loadIRPocket();

			const [data1, data2] = await Promise.all([
				news1Promise,
				news2Promise
			]);

			// 日付キーを統一
			const normalized1 = data1.rt_bn_news_list.map(item => ({ ...item, _date: new Date(item.rt_cf_n_date.datetime) }));
			const normalized2 = data2.map(item => ({ ...item, _date: new Date(item.published) }));
			const merged = [...normalized1, ...normalized2];

			// 降順ソート（新しい順）
			merged.sort((a, b) => b._date - a._date);

			return merged;
		}

		fetchAndMergeNews().then(mergedNews => {
			if (mergedNews.length) {
				document.querySelectorAll('.top-news .news-list').forEach(list => {
					const target = list.getAttribute('data-target');

					Vue.createApp({
						data() {
							return {
								jsonData: mergedNews,
								count: 5
							}
						},
						methods: {
							// IRポケット用
							setDate(published) {
								let date = published?.slice(0, 10) ?? ''
								return date.replace(/-/g, '.');
							},
							newIcon(published) { // 一ヶ月以内ならNEW
								const thisDate = new Date(published);
								const now = new Date();
								const aMonthsAgo = new Date(now);
								aMonthsAgo.setMonth(now.getMonth() - 1);
								return thisDate >= aMonthsAgo && thisDate <= now;
							},

							// CMSoD用
							setBr(content) {
								return content.replace(/\r?\n/g, '<br>');
							},
							setAttachment(item) {
								if (item.rt_cf_n_href.class && item.rt_cf_n_href.class === 'rt_cf_nolink') {
									return 'nolink';
								} else if (item.rt_cf_n_href.href.endsWith('.pdf')) {
									return 'pdf';
								} else if (FUNCTIONS.va.newsFileType.some(type => item.rt_cf_n_href.href.endsWith(type))) {
									return 'file';
								} else if (item.rt_cf_n_type3_ext_link_is !== null) {
									return 'blank';
								} else {
									return 'link';
								}
							},
							setTarget(att) {
								if (att === 'link') {
									return '_self';
								} else {
									return '_blank';
								}
							},
							setFilesize(bytes) {
								let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
								if (bytes === 0) {
									return 'n/a';
								}
								let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
								if (i === 0) {
									return bytes + sizes[i];
								}
								return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
							}
						},
						computed: {
							filterItems() {
								let items = this.jsonData;
								let itemsTemp = [];

								switch (target) {
									case 'notice':
										items.forEach(ele => {
											if (ele.cf_n_category && ele.cf_n_category.cf_nc_code === 'notice') {
												itemsTemp.push(ele);
											}
										});
										items = itemsTemp;
										break;

									case 'exhibitions_and_events':
										items.forEach(ele => {
											if (ele.cf_n_category && ele.cf_n_category.cf_nc_code === 'exhibitions_and_events') {
												itemsTemp.push(ele);
											}
										});
										items = itemsTemp;
										break;

									case 'ir_news':
										items.forEach(ele => {
											if ((ele.cf_n_category && ele.cf_n_category.cf_nc_code === 'ir_news') || ele.published) {
												itemsTemp.push(ele);
											}
										});
										items = itemsTemp;
										break;

									default:
										break;
								}

								itemsTemp = [];
								let count = this.count;
								if (count > items.length) { count = items.length; }
								for (let i = 0; i < count; i++) {
									itemsTemp.push(items[i]);
								}
								items = itemsTemp;

								return (items);
							}
						}
					}).mount(`#vue-app_${target}`);
				});
			}
		});

		FUNCTIONS.tabSwitch();
	};

	const prodBrandSlider = () => {
		const swiper = new Swiper('.top-prodBrand-slider.swiper', {
			loop: true,
			loopAdditionalSlides: 1,
			effect: 'slide',
			speed: 500,
			autoplay: false,
			slidesPerView: 1,
			spaceBetween: 16,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 2
				},
				1025: {
					slidesPerView: 2,
					spaceBetween: 40,
					pagination: false,
				}
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		mainVis();
		topicsSlider();
		newsList();
		prodBrandSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
